import EventDialog from './index.vue'

EventDialog.install = vue => {
  vue.component('EventDialog', EventDialog)
}

export default EventDialog
